module.exports = __webpack_public_path__ + "img/deny.2508eee2.svg";